var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRuleTypeOr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "educative-toys-maths copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OrService---Settings-2A---Full-width",
    transform: "translate(-813.000000, -1067.000000)",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "OrGroup-20",
    transform: "translate(490.000000, 1003.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OrGroup-19",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OrGroup-10",
    transform: "translate(309.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "or-educative-toys-maths-copy",
    transform: "translate(15.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "OrRectangle",
    stroke: "#000000",
    x: 0.3125,
    y: 0.3125,
    width: 39.375,
    height: 39.375,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "OrOval",
    stroke: "#C1C1C1",
    cx: 29.1665,
    cy: 29.1875,
    r: 5.25
  }), /*#__PURE__*/React.createElement("polygon", {
    stroke: "#C1C1C1",
    points: "5.5625 34.4375 10.8125 23.9375 16.0625 34.4375"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "OrRectangle2",
    stroke: "#C1C1C1",
    x: 5.5625,
    y: 6.875,
    width: 10.5,
    height: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "OrPath",
    d: "M29.21725,5.986 L30.7345,9.99175 L33.68675,9.99175 C33.9893087,9.982794 34.2655474,10.1628767 34.379442,10.4433228 C34.4933366,10.7237688 34.4208797,11.0454636 34.19775,11.25 L31.634,13.042 L33.055,16.304 C33.1824544,16.6104599 33.1001875,16.964073 32.8505493,17.1828036 C32.6009112,17.4015342 32.2395539,17.4366203 31.9525,17.27 L28.52075,15.345 L25.089,17.27 C24.8019461,17.4366203 24.4405888,17.4015342 24.1909507,17.1828036 C23.9413125,16.964073 23.8590456,16.6104599 23.9865,16.304 L25.4075,13.042 L22.84375,11.25 C22.6148498,11.0474933 22.5380666,10.7228999 22.6519777,10.4393006 C22.7658888,10.1557013 23.0458682,9.97440589 23.35125,9.9865 L26.3,9.9865 L27.819,5.98075 C27.9536099,5.71794228 28.224463,5.5530557 28.5197366,5.5541588 C28.8150101,5.55527302 29.0846174,5.72218887 29.21725,5.986 Z",
    stroke: "#000000",
    fill: "#000000"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleTypeOr);
export default __webpack_public_path__ + "static/media/rule-type-or.69ae2236.svg";
export { ForwardRef as ReactComponent };